export default __webpack_public_path__ + "static/media/TOS_symbolDark.926fa3fc.svg";